import { FAQs } from 'routes/external'
import { Typography, GlowHeading, Icon, Link, Grid } from '~ui'
import { IconTypes } from '~ui/Icon'
import { useScreenClass } from '~hooks'
import Subscribe from './subscribe'

import styles from './TourSide.module.scss'

const { Paragraph, Text } = Typography

const TourSidebar = () => {
  const { isMobile } = useScreenClass()

  const offeringsList = [
    { iconName: 'meet&greet', text: 'Meet & Greets' },
    { iconName: 'packages', text: 'VIP Packages' },
    { iconName: 'auction', text: 'Auctions' },
    { iconName: 'ticket', text: 'Event tickets' },
  ]

  return (
    !isMobile && (
      <>
        <div className={styles.image}>
          <img src="https://img.granted.co/1641909788830-tour.jpg" alt="Granted Logo" />
        </div>
        <div className={styles.wrapper}>
          <div className={styles.content}>
            <GlowHeading Tag="h2" size="h1">
              Access, Granted.
            </GlowHeading>
            <Paragraph color="g-gray-1" size="body" lineHeight="body">
              Whether you want to meet the artist, watch from the front row, or dance in the
              bleachers, Granted has the access you’re looking for. Offerings vary per event.
            </Paragraph>
            <Grid gap={30} paddingBottom={20}>
              {offeringsList.map((offerings) => (
                <Grid className={styles['offer-item']}>
                  <Icon name={offerings.iconName as IconTypes} fill="currentColor" color="white" />
                  <Text size="lg" bold>
                    {offerings.text}
                  </Text>
                </Grid>
              ))}
            </Grid>

            <Subscribe />

            <div className={styles.separator} />
            <GlowHeading Tag="h3">Why buy with Granted?</GlowHeading>
            <Paragraph color="g-gray-1" size="body" lineHeight="body">
              <Text color="g-white" size="body" lineHeight="body">
                Granted aims to treat every fan like a VIP.
              </Text>{' '}
              We want to help you find experiences of a lifetime, and we want to be there at each
              step of the way to ensure you have a fantastic night out.
            </Paragraph>

            <Paragraph color="g-gray-1" size="body" lineHeight="body">
              <Text color="g-white" size="body" lineHeight="body">
                Here you’ll find the best of the best.
              </Text>{' '}
              You’ll also have exclusive access to a range of experiences you won’t find anywhere
              else - through Granted’s exclusive Auctions.
            </Paragraph>

            <Paragraph color="g-gray-1" size="body" lineHeight="body">
              Have more questions?{' '}
              <Link target="_blank" rel="noreferrer" external href={FAQs}>
                Visit our FAQ.
              </Link>
            </Paragraph>
          </div>
        </div>
      </>
    )
  )
}

export default TourSidebar
